import { createSelector } from 'reselect';

import type { RootState } from 'reducers/index';
import { getProps } from 'utils/selectors';

import type { StoredChecklist } from '../types';

type State = Pick<RootState, 'checklists'>;

export const getState = (state: State) => state.checklists;

export const getDataState = createSelector(getState, state => state.data);

export const getUI = createSelector(getState, state => state.ui);

export const getStack = createSelector(getUI, ui => ui.stack);

export const getAllChecklists = createSelector(
  getDataState,
  data => data.byId
);

export const getChecklistById = createSelector(getAllChecklists, getProps<string>, (checklists, id) =>
  checklists[id]) as unknown as <T = StoredChecklist>(state: State, id: string) => T;

export const getChecklistsByIds = createSelector(getAllChecklists, getProps<string[]>, (checklists, ids) =>
  ids.map(id => checklists[id]).filter(Boolean)) as unknown as <T = StoredChecklist>(state: State, ids: string[]) => T[];
